
window.odTheme = window.odTheme || {};

window.odTheme.utils = {

  each: function(collection, iterator) {
      if (Array.isArray(collection)) {
          for (var i = 0; i < collection.length; i++)
              iterator(collection[i], i, collection);
      } else if (collection instanceof Object) {
          for (var key in collection)
              iterator(collection[key], key, collection);
      } else if (collection === null) {
          return collection;
      }
  },

  extend: function(obj) {
      window.odTheme.utils.each(arguments, function(extendObj) {
          for (var key in extendObj)
              obj[key] = extendObj[key];
      });
      return obj;
  },

  initAccordion: function(container){
    var self = this;

    var accordionTitles = container.querySelectorAll('.accordion-title');

    for (var i = 0; i < accordionTitles.length; i++) {
      var accordionTitle = accordionTitles[i];

      accordionTitle.addEventListener('click', function(){
        var closeActive = false;
        if (this.classList.contains('active')){
          closeActive = true;
        }

        for (var k = 0; k < accordionTitles.length; k++) {
          accordionTitles[k].classList.remove('active');
        }

        if (!closeActive){
          this.classList.add('active');
        }
        
      });
    }

  },

  /**
   * Cross-browser URL query param getter
   */
  getQueryParams: function(qs) {
    qs = qs || document.location.search;

    if (!qs) { 
      return;
    }

    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  },


};

